<template lang="pug">
.headerUserComponent
  ui-loader(v-if="user.isLoading")
  template(v-else-if="user.isAuthenticated && !isHomepage")
    .headerUserWrapper(v-click-outside="onClickOutside")
      .name {{ computedName }}
      .avatarsWrapper(@click="toggleDropdown")
        .avatars
          .avatar
            ui-avatar(
              :url="user.profile.avatarUrl"
              :size="40"
            )
          .avatar.child(v-if="child && !child.isDefault")
            ui-avatar(
              :url="user.selectedChild.avatarUrl"
              :size="40"
            )
          .placeholder(v-else)
        .arrowWrapper
          ui-svg-icon(
            name="arrow-up"
            class="arrow"
            :class="{'arrow-down': !isShowDropdown}"
          )

    template(v-if="isShowDropdown || isMobileMenuOpen")
      .dropdown
        .container
          .personsWrapper
            template( v-if="isMobileMenuOpen")
              .parent
                ui-person(
                  :urlPerson="user.profile.avatarUrl"
                  :firstName="user.profile.firstName"
                  :is-parent="true"
                  :is-disabled="true"
                )
            .children(v-if="user.profile.children.length")
              ui-person.child(
                v-for="child in user.profile.children"
                :key="child.id"
                :urlPerson="child.isDefault ? child.parent.avatarUrl : child.avatarUrl"
                :firstName="child.firstName"
                :is-selected="user.selectedChild.id === child.id"
                @click="onNameChildClick(child.id)"
              )
          router-link.link(
            :to="{name: 'Profile'}"
            @click="closeDropdown"
          ) Профиль
          a.link(
            :href="PORTFOLIO_URL"
            target="blank"
            @click="closeDropdown"
          ) Мой портфель
          .bottom
            ui-button.exit(
              is-responsive
              @click.stop="onLogoutButtonClick"
            )
              span.exit-title Выход
              .exit-icon
                ui-svg-icon(
                  name="exit"
                  :original-colors="true"
                )

  template(v-else-if="user.isAuthenticated && isHomepage")
    router-link(:to="{name: 'Catalog'}")
      ui-button.personal-account-button(
        color="orange-hover"
      ) Перейти в сервис

  template(v-else)
    ui-button.personal-account-button(
      :is-loading="user.isLoading",
      color="orange-hover"
      @click="onLoginButtonClick"
    ) Войти
</template>

<script>
import { PORTFOLIO_URL } from '@/config'
import ClickOutsideDirective from '@/_core/directives/click-outside'
import useFlag from '@/_core/hooks/useFlag'
import useWindowBreakpointCallback from '@/_core/hooks/useWindowBreakpointCallback'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  directives: {
    'click-outside': ClickOutsideDirective
  },
  inject: ['store'],
  props: {
    isMobileMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const { flag: isShowDropdown, toggle: toggleDropdown, off: closeDropdown } = useFlag(
      '_isDropdownOpened',
      false
    )
    useWindowBreakpointCallback(825, closeDropdown)

    const route = useRoute()
    const isHomepage = computed(() => route.name === 'Home')

    return {
      isShowDropdown,
      toggleDropdown,
      closeDropdown,
      isHomepage,
      PORTFOLIO_URL
    }
  },
  computed: {
    user () {
      return this.store.user
    },
    parent () {
      return this.user.profile
    },
    child () {
      return this.parent.hasChildren ? this.user.selectedChild ?? null : null
    },
    computedName () {
      return `${this.parent.firstName}${
        this.child && !this.child.isDefault ? ` и ${this.child.firstName}` : ''
      }`
    }
  },
  methods: {
    onLoginButtonClick () {
      this.user.login()
    },
    onLogoutButtonClick () {
      this.user.logout()
    },
    onNameChildClick (childId) {
      this.user.selectChild(childId)
      this.closeDropdown()
    },
    onClickOutside () {
      this.closeDropdown()
    }
  }
}
</script>

<style lang="sass" scoped>
$borderRadiusWrap: 20*$u
$borderRadiusElem: 0.5*$u
$heightHeaderUserComponent: 11*$u
$topDropdown: $heightHeaderUserComponent + 3*$u

.headerUserComponent
  width: fit-content
  display: flex
  position: relative

  > .headerUserWrapper
    height: $heightHeaderUserComponent
    position: relative
    display: flex
    align-items: center
    border-radius: $borderRadiusWrap
    background-color: $cElements
    padding-left: 5*$u
    @include font('t16-demibold')
    line-height: 1

    > .name
      margin-right: 2*$u
      max-width: 50*$u
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

    > .avatarsWrapper
      flex-shrink: 0
      cursor: pointer
      border-radius: $borderRadiusWrap
      background-color: $cBlue
      padding-left: $borderRadiusElem
      height: 100%
      display: flex
      align-items: center

      > .avatars
        display: flex
        align-items: center
        > .avatar
          &:first-child
            position: relative
            z-index: 2
          &.child
            position: relative
            left: -2.5*$u
            z-index: 1

        > .placeholder
          width: 2*$u

      > .arrowWrapper
        width: 3*$u
        height: 3*$u
        flex: 0 0 3*$u
        margin-right: 3.5*$u
        > .arrow
          color: transparent
          &.arrow-down
            transform: rotate(180deg)

  > .dropdown
    min-width: 48*$u
    position: absolute
    top: $topDropdown
    right: 0
    z-index: 100
    border-radius: 0 0 $brS $brS
    background: $cWhite
    box-shadow: $boxShadow

    > .container

      .children
        padding: 2*$u

      > .link
        position: relative
        height: 15*$u
        display: flex
        justify-content: flex-start
        align-items: center
        padding: 0 16px
        background-color: transparent
        color: $cBlack
        @include font('t18-demibold')
        overflow: hidden
        &:hover
          background-color: $cElements
        &:before
          content: ''
          display: block
          position: absolute
          top: 0
          left: -$appSidePaddingDesktop
          width: 100vw
          height: 1px
          background: $cBackground
      > .bottom
        > .exit
          position: relative
          height: 15*$u
          display: flex
          justify-content: flex-start
          border-radius: 0 0 $brS $brS
          background-color: transparent
          color: $cBlack
          @include font('t18-demibold')
          overflow: hidden
          &:before
            content: ''
            display: block
            position: absolute
            top: 0
            left: -$appSidePaddingDesktop
            width: 100vw
            height: 1px
            background: $cBackground
          &:hover
            background-color: $cElements
          .exit-icon
            width: 7*$u
            height: 7*$u
            flex: 0 0 7*$u
            margin: 4*$u

  .personal-account-button
    min-width: 43*$u

  @media (max-width: $XLWidth)
    .header-user-wrap
      .name
        max-width: 40*$u

  @media (min-width: $padWidth) and (max-width: 1028px)
    .headerUserWrapper
      background-color: transparent
      padding: 0
      .name
        display: none

  @media (max-width: $padWidth)
    flex: 1
    margin-left: 0

    .headerUserWrapper
      display: none

    .dropdown
      width: 100%
      position: relative
      left: auto
      top: auto
      bottom: auto
      right: auto
      border-radius: 0
      box-shadow: none
      > .container
        height: 100%
        display: flex
        flex-direction: column
        justify-content: space-between
        > .personsWrapper
          > .parent
            padding: 0
          > .children
            padding: 0 0 6*$u

        > .bottom
          > .exit
            height: 26*$u
            padding-left: 0
            padding-right: 0
            overflow: initial
            position: relative

            .exit-title
              font-size: 5.5*$u

            &:before
              content: ' '
              position: absolute
              height: 0.5*$u
              top: 0
              right: -$appSidePaddingDesktop
              left: -$appSidePaddingDesktop
              background-color: $cBackground

    .personal-account-button
      position: absolute
      top: 9*$u
      left: 0

  @media (max-width: $mobileWidth)
    .dropdown
      > .container
        > .personsWrapper
          > .parent
            margin: 4*$u 0
          > .children
            > .child
              margin-bottom: 3*$u
        > .bottom
          > .exit
            .exit-title
              font-size: 5*$u
</style>
